import React from 'react';
import { Container, Row, Column } from '@src/elements/Grid';
import { COLOR_PRIMARY } from '@src/types/colors';
import { ButtonLinkStandard } from '../ButtonLink';
import styles from './VcdLink.module.scss';
import Heading from '@src/elements/Heading';

interface VcdLink {
  documentUrl?: string;
}

const VcdLink: React.FC<VcdLink> = ({ documentUrl }) => {
  return (
    <Container>
      <Row>
        <Column
          alignXs="center"
          alignSm="center"
          alignMd="center"
          alignLg="center"
          alignXl="center"
          alignXxl="center"
        >
          <div className={styles.vcdLink}>
            <Heading priority={4} fontStyle="h4">
              View the Village Comparison Document (VCD)
            </Heading>
            <ButtonLinkStandard
              color={COLOR_PRIMARY}
              href={documentUrl}
              openNewWindow
              icon="Pdf"
              iconPosition="left"
            >
              View document
            </ButtonLinkStandard>
          </div>
        </Column>
      </Row>
    </Container>
  );
};

export default VcdLink;
